import { configure } from 'mobx';

configure({
    computedRequiresReaction: true,
    reactionRequiresObservable: false,
    observableRequiresReaction: false,
    disableErrorBoundaries: false,
});
